export default __webpack_public_path__ + "static/media/perfecto_flush_1.d49c9429.jpeg";